import React, { useState } from 'react';
import BackButton from './BackButton';
import AntCoinImg from './images/AntCoin.png';
import PrizeImg from './images/Icon_Trophy.png';
import LotteryTicketImg from './images/LotteryTicket.png';

function PastLottery({ goBack, changeActiveComponent }) {
    const [selectedItem, setSelectedItem] = useState(null);

    const handleItemClick = (item) => {
      setSelectedItem(item);
    };

    return (
        <section id="shop">
          <div className="platform-container">
            <button className="lottery-rules-button" id="right2">INFO/RULES</button>
            <BackButton goBack={goBack} title="LOTTERY - PAST DRAWS" />
            <div className="inventory-container" id="lottery-container">
                <div className="inventory-container-left" id="lottery-left">
                    <p className="lottery-info-p">Total Prize Pool</p>
                    <div className="lottery-total-prize"><img src={PrizeImg}/><h1>$13 823</h1></div>
                    <p className="lottery-info-p">Winning Numbers</p>
                    <div className="lottery-timer-container">
                        <div className="lottery-timer-box"><h2>0</h2></div>
                        <div className="lottery-timer-box"><h2>0</h2></div>
                        <div className="lottery-timer-box"><h2>0</h2></div>
                        <div className="lottery-timer-box"><h2>1</h2></div>
                        <div className="lottery-timer-box"><h2>1</h2></div>
                        <div className="lottery-timer-box"><h2>1</h2></div>
                    </div>
                    <button className="lottery-button" id="right1">CLAIM WINNINGS</button>
                    <p className="lottery-info-p">Round: X 01/02/2022 <br></br>
                    0x021389391239hbf0379faf78as8f876as78f</p>
                    <div className="nextprev-button"><button>PREVIOUS</button><button>NEXT</button></div>
                    </div>
                    <div className="inventory-container-right" id="lottery-right">
                        <h1>Your Tickets For This Draw</h1>
                        <div className="lottery-tickets-container">
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>

                        </div>
                </div>
                </div>
              </div>
        </section>
      );
    }
    
    export default PastLottery;